import { PrimaryColors } from '@/common/theme/constants';
import { SxProps } from '@mui/material';

export const priceSliderContainerStyles: SxProps = {
  marginBottom: '8px',
  borderBottom: `1px solid ${PrimaryColors.black}`,
  paddingBottom: '8px',
};

export const priceSliderWrapperStyles: SxProps = {
  padding: '0 8px',
};

export const priceSliderStyles: SxProps = {
  color: PrimaryColors.black,
  '& .MuiSlider-thumb': {
    backgroundColor: PrimaryColors.black,
  },
  '& .MuiSlider-track': {
    backgroundColor: PrimaryColors.black,
  },
  '& .MuiSlider-rail': {
    backgroundColor: '#e0e0e0',
  },
  '& .MuiSlider-valueLabel': {
    backgroundColor: PrimaryColors.black,
  },
};
